/*
 * views/spaView.js
 * Spa View
 */

define( 'app/views/golfView',[
    'lib/event',
    'moment',
    'app/views/commonViewHelper',
    'hbs!app/views/templates/navbar',
    'hbs!app/views/templates/breadcrumbs',
    'hbs!app/views/templates/content',
    'hbs!app/views/templates/golfLocationList',
    'hbs!app/views/templates/golfCourseList',
    'hbs!app/views/templates/golfTeeInfo',
    'hbs!app/views/templates/golfTeeTimeSelection',
    'hbs!app/views/templates/golfBookConfirm',
    'hbs!app/views/templates/golfPartialPayment',
    'hbs!app/views/templates/golferInformationModal',
    'bootstrap',
], function( Event, moment, commonViewHelper, navbarTpl, breadcrumbsTpl, contentTpl, golfLocationList, golfCourseList, golfTeeInfoTpl, golfTeeSelection, golfBookConfirm,golfPartialPayment, golferInformationModalTpl){
    var golfView = {
        app : app,
        event : $.extend({},Event),
        module : "golfBooking",
        render: function(template,data,breadcrumbs) {

        }
    };
    var setBreadCrumb = function( crumbText, crumbLink ) {
        app.data.breadCrumbs = app.data.keepCrumb || {};
        app.data.breadCrumbs.golf = app.data.breadCrumbs.golf || [];
        var spliceCrumbsAt = -1,
            existingCrumb = $.grep(app.data.breadCrumbs.golf,function(crumb,index){
                if (crumb.url==crumbLink) {
                    spliceCrumbsAt = index;
                    return true;
                }
                return false;
            }),
            currentCrumb = {name:crumbText,url:crumbLink};

        app.data.breadCrumbs.golf = existingCrumb.length ?
            $.merge(app.data.breadCrumbs.golf.slice(0,spliceCrumbsAt),[currentCrumb]) :
            $.merge(app.data.breadCrumbs.golf,[currentCrumb]);

        for(var i=0;i<app.data.breadCrumbs.golf.length;i++) {
            app.data.breadCrumbs.golf[i].last = i==(app.data.breadCrumbs.golf.length-1);
        }

        app.datal('keepCrumb', {golf: app.data.breadCrumbs.golf || []});
    };

    golfView.event.listen('requestGolfLocationSelection', golfView, function(e, golfLocations){
        console.log('reading service types');
         $('#main').append('<div id="vue-app" />');
       
        var service = $.firstOrOnly($.grep( app.data.serviceTypes, function(a){
            return a.id==app.views.golfView.module
        }));
        app.data.breadCrumbs.golf = [{name:app.localization.golf.title,url:"#/golfBooking",last:true}];
        app.datal('keepCrumb', {golf: [{name:app.localization.golf.title,url:"#/golfBooking",last:true}]});
        $('#nav').html( navbarTpl( {
            Customization:app.customization,
            Localization : app.localization,
            services : app.data.serviceTypes,
            languages : app.data.languageNames,
            siteName : app.localization.siteName,
            backLink : Customization.serverURL
        }) );
        $('#main').html( contentTpl( {
            Localization : app.localization,
            services : app.data.serviceTypes,
            bannerMessage : app.localization.golf.marketing.bannerMessage,
            siteName : app.localization.siteName,
            backLink : Customization.serverURL,
            service : service
        }) );
        console.log(golfLocations, service)
        $('#content').addClass('golfLocationList').html( golfLocationList( {
            Localization : app.localization,
            golfLocations : commonViewHelper.sortHelper(golfLocations),
            showitem: // $.firstOrOnly(golfLocations).LocationId
                    $.isArray(golfLocations) && golfLocations.length==1
                        ? $.firstOrOnly(golfLocations).LocationId : ""
        }));
        $('#breadcrumbs').html( breadcrumbsTpl({
            'breadCrumbs':app.data.breadCrumbs.golf
        }) )
        commonViewHelper.updateNavBar(service,app.language,app.models.systemModel.dataModel.folioBalance.data[app.models.systemModel.makeStandardName(app.models.systemModel.dataModel.folioBalance,{})]);
        commonViewHelper.showMessages();
        // TODO: view item list
        commonViewHelper.analyticsInit('requestGolfLocationSelection', [golfLocations]);
    });

    golfView.event.listen('requestGolfCourseSelection', golfView, function(e, golfLocations, golfCourses){

        var golfLocation = $.firstOrOnly($.grep( golfLocations, function(a){
            return a.LocationId==app.models.golfModel.getSelectedValue("golfLocations");

        }));

        setBreadCrumb(golfLocation.LocationName,"#/golfBooking/location/"+app.models.golfModel.getSelectedValue("golfLocations"));

        var service = $.firstOrOnly($.grep( app.data.serviceTypes, function(a){
            return a.id==app.views.golfView.module
        }));
        $('#nav').html( navbarTpl( {
            Localization : app.localization,
            Customization:app.customization,
            services : app.data.serviceTypes,
            languages : app.data.languageNames,
            siteName : app.localization.siteName,
            backLink : Customization.serverURL
        }) );
        $('#main').html( contentTpl( {
            Localization : app.localization,
            bannerMessage : app.localization.golf.marketing.bannerMessage,
            service : service
        }) );
        $('#content').addClass('golfCourseList').html( golfCourseList( {
            Localization : app.localization,
            golfCourse :  commonViewHelper.sortHelper(golfCourses),
            showitem: // $.firstOrOnly(golfCourses).CourseId
                $.isArray(golfCourses) && golfCourses.length==1
                    ? $.firstOrOnly(golfCourses).CourseId : ""
        }));
        $('#breadcrumbs').html( breadcrumbsTpl({
            'breadCrumbs':app.data.breadCrumbs.golf
        }) )
        commonViewHelper.updateNavBar(service,app.language,app.models.systemModel.dataModel.folioBalance.data[app.models.systemModel.makeStandardName(app.models.systemModel.dataModel.folioBalance,{})]);
        commonViewHelper.showMessages();
        commonViewHelper.analyticsInit('requestGolfCourseSelection', [golfLocations, golfCourses]);
    });

    golfView.event.listen('requestGolfTeeInfo', golfView, function(e, golfCourses, golfLocation, startDate, startTime, endDTime, numberOfPlayers, groupCode){

        app.datal('golfCourseList', golfCourses);

        var golfCourse = $.firstOrOnly($.grep( golfCourses, function(a){
            return a.CourseId==app.models.golfModel.getSelectedValue('golfCourses');
        }));

        golfCourse && setBreadCrumb(golfCourse.CourseName,"#/golfBooking/course/"+app.models.golfModel.getSelectedValue("golfCourses"));

        var service = $.firstOrOnly($.grep( app.data.serviceTypes, function(a){
            return a.id==app.views.golfView.module
        }));
        var dateList = (_.isArray(app.customization.golfBooking.PMSRoomMandatory) && _.contains(app.customization.golfBooking.PMSRoomMandatory, golfCourse.CourseId))
                        ? ( !!app.data.pmsDateList ? app.data.pmsDateList[golfLocation.PropertyId] : [] )
                        : [];
        if (app.data.RestrictedFolio) {
            dateList = app.data.datesForRestrictedFolio
        }
        var now = (new Date()).setHours(0,0,0,0)
        dateList =  _.filter(dateList,function (dates) {
            var d2 = new Date(dates.machine).setHours(0,0,0,0)
           return d2>=now
        })
        var showDateList = false;
        if (!app.data.overridePMSRestriction && _.isArray(dateList) && dateList.length > 0) {
            showDateList = true;
            if(!_.any(dateList,function(x){return x.machine == startDate})) {
                startDate = dateList[0].machine;
            }
        }

        $('#main').html( contentTpl( {
            Localization : app.localization,
            bannerMessage : app.localization.golf.marketing.bannerMessage,
            service : service
        }) );
        $('#content').addClass('golfTeeInfo').html( golfTeeInfoTpl( {
            Localization : app.localization,
            Customization:app.customization,
            course: app.models.golfModel.getSelectedValue("golfCourses"),
            startDate:startDate,
            startTime:startTime,
            endDTime:endDTime,
            numberOfPlayers:numberOfPlayers,
            showDateList:showDateList,
            dateList:dateList,
            groupCode: groupCode
        } ));
        $('#breadcrumbs').html( breadcrumbsTpl({
            'breadCrumbs':app.data.breadCrumbs.golf
        }) )
        commonViewHelper.prepGolfForm(golfLocation, startTime, app.models.golfModel.getSelectedValue("golfCourses"), undefined, startDate);
        commonViewHelper.updateNavBar(service,app.language,app.models.systemModel.dataModel.folioBalance.data[app.models.systemModel.makeStandardName(app.models.systemModel.dataModel.folioBalance,{})]);
        commonViewHelper.showMessages();
    });

    golfView.event.listen('requestTeeTimeSelection', golfView, function(e, golfTeeInfo, numberOfPlayers, startDate, startTime, endDTime, groupCode, playerOverLimit){
        if(!golfTeeInfo) golfTeeInfo = {TeeTime: []};
        var crs = _.find(app.data.golfCourseList, function(el){ return el.CourseId == (golfTeeInfo.CourseId || app.dispatcher.currentRoute[3])});
        setBreadCrumb(crs ? crs.CourseName : golfTeeInfo.CourseId,"#/golfBooking/course/"+app.models.golfModel.getSelectedValue("golfCourses"));

        var service = $.firstOrOnly($.grep( app.data.serviceTypes, function(a){
            return a.id==app.views.golfView.module
        }));
        // sort tee times acording to WebSort field
        if(golfTeeInfo.TeeTime){
            _.each(golfTeeInfo.TeeTime, function(teeTime){
                if(teeTime.Rates && teeTime.Rates.Rate && $.wrapArray(teeTime.Rates.Rate).length > 1){
                    teeTime.Rates.Rate = commonViewHelper.sortHelper(teeTime.Rates.Rate);
                }
            })
        }
        if((app.customization.golfBooking.enableGolferNamesModal || !app.data.userLoggedIn) && golfTeeInfo.TeeTime && golfTeeInfo.TeeTime.length > 0){
            // filter rated based on duration restriction
            var selectedCourse = app.models.golfModel.getSelectedItem('golfCourses', {'LocationId':app.models.golfModel.getSelectedValue('golfLocations')})
            var hasTimeRestriction = selectedCourse && selectedCourse.RestrictDuration && selectedCourse.RestrictDuration === 'Y';
            var timeRestrictionDuration = selectedCourse && selectedCourse.PlayDuration ? selectedCourse.PlayDuration : 0;

            if(hasTimeRestriction){
                // remove tee times that are not in the time restriction
                golfTeeInfo.TeeTime = _.filter(golfTeeInfo.TeeTime, function(teeTime){
                    var showTeeTime = true;
                    // check cart
                    var cartData = app.data.cartData
                    if(cartData && cartData.rawData && cartData.rawData.WebFolioItem){
                        var webFolioItems = $.wrapArray(cartData.rawData.WebFolioItem)
                        _.each(webFolioItems, function(booking){
                            var bookeTeeTime = moment(booking.DisplayStartTime, 'YYYY-MM-DDHHmmss');
                            var currentTeeTime = moment(teeTime.DateTime, 'YYYY-MM-DDHHmmss');
                            var durationInMinutes = moment.duration(currentTeeTime.diff(bookeTeeTime)).asMinutes();
                            if(Math.abs(durationInMinutes) <= parseInt(timeRestrictionDuration)){
                                showTeeTime = false;
                            }
                        });
                    }
                    // check future bookings
                    if(app.data.golfBookings){
                        _.each(app.data.golfBookings, function(booking){
                            var bookeTeeTime = moment(booking.BookingTime, 'YYYY-MM-DDHHmmss');
                            var currentTeeTime = moment(teeTime.DateTime, 'YYYY-MM-DDHHmmss');
                            var isBookedTeeTimeToday = moment(booking.BookingTime, 'YYYY-MM-DDHHmmss').isSame(currentTeeTime, 'day');
                            var isBookedTeeTimeInFuture = moment(booking.BookingTime, 'YYYY-MM-DDHHmmss').isAfter(currentTeeTime, 'day');
                            if(isBookedTeeTimeToday || isBookedTeeTimeInFuture){
                                var durationInMinutes = moment.duration(currentTeeTime.diff(bookeTeeTime)).asMinutes();
                                if(Math.abs(durationInMinutes) <= parseInt(timeRestrictionDuration)){
                                    showTeeTime = false;
                                }
                            }
                        });
                    }
                    
                    return showTeeTime;
                });
            }
            
        }
        var firstTeeTime = $.firstOrOnly(golfTeeInfo.TeeTime);
        $('#nav').html( navbarTpl( {
            Localization : app.localization,
            services : app.data.serviceTypes,
            languages : app.data.languageNames,
            siteName : app.localization.siteName,
            backLink : Customization.serverURL
        }) );
        $('.alert:not(.alert-uptime, .alert-no-autoclose)').alert('close');
        if ($('#golfResults').length==0) {
            $('#main').html( contentTpl( {
                Localization : app.localization,
                bannerMessage : app.localization.golf.marketing.bannerMessage,
                service : service
            }) );
        }
        if ($('#golfResults').length==0) {
            $('#content').addClass('golfTeeInfo').html( golfTeeInfoTpl( {
                Localization : app.localization,
                Customization:app.customization,
                course: app.models.golfModel.getSelectedValue("golfCourses"),
                startDate:startDate,
                startTime:startTime,
                endDTime:endDTime,
                numberOfPlayers:numberOfPlayers,
                groupCode: groupCode,
            } ));
            commonViewHelper.prepGolfForm(app.models.golfModel.getSelectedItem('golfLocations',{}), startTime,  app.models.golfModel.getSelectedValue("golfCourses"), 1, startDate);
            commonViewHelper.updateNavBar(service,app.language,app.models.systemModel.dataModel.folioBalance.data[app.models.systemModel.makeStandardName(app.models.systemModel.dataModel.folioBalance,{})]);
            commonViewHelper.analyticsInit('requestTeeTimeSelection', [golfTeeInfo, startDate, groupCode]);
        }

        if(_.isEmpty(golfTeeInfo.TeeTime)){
            $("#golfTeeTime").parents(".control-group").hide();
        }else{
            $("#golfTeeTime").parents(".control-group").show();
        }
       //for anonymous users
       var enableGolferNamesModal = app.customization.golfBooking.enableGolferNamesModal;
       var enableGolfMemberRoster = app.customization.golfBooking.enableGolfMemberRoster;

       if(app.customization.golfBooking.enableGolfMemberRoster && !app.customization.golfBooking.forceLoginOnModal && !app.data.userLoggedIn){
            enableGolfMemberRoster = false;
            enableGolferNamesModal = true;
        }
        

        $('#golfResults').html( golfTeeSelection( {
            Localization : app.localization,
            Customization: app.customization,
            enableGolfMemberRoster: enableGolfMemberRoster,
            enableGolferNamesModal: enableGolferNamesModal,
            teeInfo: golfTeeInfo,
            firstTeeTime: firstTeeTime,
            numberOfPlayers: numberOfPlayers,
            groupCode: groupCode,
            location: app.models.golfModel.getSelectedValue("golfLocations"),
            playerOverLimit: playerOverLimit
        } ));

        $('#breadcrumbs').html( breadcrumbsTpl({
            'breadCrumbs':app.data.breadCrumbs.golf
        }) )
        commonViewHelper.updateNavBar(service,app.language,app.models.systemModel.dataModel.folioBalance.data[app.models.systemModel.makeStandardName(app.models.systemModel.dataModel.folioBalance,{})]);
        commonViewHelper.updatedTeeTimes(app.models.golfModel.getSelectedItem('golfLocations',{}), app.models.golfModel.getSelectedValue("golfCourses"), numberOfPlayers, startDate, groupCode);
        commonViewHelper.showMessages();
        commonViewHelper.prepBookTeeTimeButtons(golfTeeInfo.CourseId, groupCode);
    });
    
    golfView.event.listen('showGolferInformationModal', golfView, function(e, courseId, dateTime, maxSlots, rateId, groupCode, price, golfRates, locationId, groupMembers, clubDirectory, displayTime){

        if(app.customization.golfBooking.enableGolfMemberRoster && app.customization.golfBooking.enableGolferNamesModal){
            // trigger error message to disable one of the two options
            app.data.messages.push({
                type: 'alert', 'class': 'alert-error', actions: [],
                title: app.localization.golf.modal.errorBothFlagsEnabled,
                message: ''
            });
            app.commonViewHelper.showMessages();
        } else {
            // Creates modal to get golf players information
            var time  = app.rs.DateToString(dateTime, "hh:mm tt");
            var displayTimeFormat = displayTime ? app.rs.DateToString(displayTime, "hh:mm tt"): app.rs.DateToString(dateTime, "hh:mm tt");
            var date = app.rs.DateToString(dateTime, "MMMM dd yyyy")
            var golfRatesArr = golfRates ? JSON.parse(golfRates) : [];
            $('#golferInformationModal').remove();
            
            var course =_.find(app.data.golfCourseList, function(el){ return el.CourseId == (courseId || app.dispatcher.currentRoute[2])});
            //for anonymous users
            var enableGolferNamesModal = app.customization.golfBooking.enableGolferNamesModal;
            var enableGolfMemberRoster = app.customization.golfBooking.enableGolfMemberRoster;
    
            if(app.customization.golfBooking.enableGolfMemberRoster && !app.customization.golfBooking.forceLoginOnModal){
                if(!app.data.userLoggedIn){
                    enableGolfMemberRoster = false;
                    enableGolferNamesModal = true;
                }
            }

            var tempFlags = {
                enableGolfMemberRoster: enableGolfMemberRoster,
                enableGolferNamesModal: enableGolferNamesModal
            };
            $('#main').append(golferInformationModalTpl({
                Localization : app.localization,
                Date: date,
                Customization: app.customization,
                enableGolfMemberRoster: enableGolfMemberRoster,
                enableGolferNamesModal: enableGolferNamesModal,
                Time: time,
                DisplayTime: displayTimeFormat,
                Course: course,
                numberOfPlayers: maxSlots,
                GolfRates: golfRatesArr,
                GroupMembers:groupMembers || [], 
                ClubDirectoryMembers: clubDirectory || [],
                isLoggedIn: app.data.userLoggedIn
            }));
            commonViewHelper.prepGolferInformationForm(courseId, dateTime, maxSlots, rateId, groupCode, price, golfRates, locationId, tempFlags);
        }
    });

    golfView.event.listen('requestGolfPartialPayment', golfView, function(e, golfFolio,folioId){
        console.log("555",folioId,golfFolio)
        var service = $.firstOrOnly($.grep( app.data.serviceTypes, function(a){
            return a.id==app.views.roomsView.module
        }));
       
        setBreadCrumb("Summary");
        $('#nav').html( navbarTpl( {
            Customization:app.customization,
            Localization : app.localization,
            services : app.data.serviceTypes,
            languages : app.data.languageNames,
            siteName : app.localization.siteName,
            backLink : app.customization.serverURL
        }) );
        $('#main').html( contentTpl( {
            Localization : app.localization,
            bannerMessage : app.localization.roomReservation.marketing.bannerMessage,
        }) );
        $('#content').addClass('golfPartialPayment').html(golfPartialPayment( {
            golfFolio:golfFolio,
            loggedInUser: app.data.CustomerId,
            folioId:folioId
        }))
        $('#breadcrumbs').html( breadcrumbsTpl({
            'breadCrumbs':"Summary"
        }) )
        commonViewHelper.updateNavBar(service,app.language,app.models.systemModel.dataModel.folioBalance.data[app.models.systemModel.makeStandardName(app.models.systemModel.dataModel.folioBalance,{})]);
        commonViewHelper.showMessages();
        commonViewHelper.handlePayment(folioId,'GOLF');
       
    })
    golfView.event.listen('requestTeeTimeConfirmation', golfView, function(e, golfRate, location, course, dateTime, numberOfPlayers){
        setBreadCrumb(Localization.golf.confirmGolfBooking,"#/golfBooking/confirm/"+golfRate);
        var service = $.firstOrOnly($.grep( app.data.serviceTypes, function(a){
            return a.id==app.views.golfView.module
        }));
        if (app.customization.golfBooking.showPriceIncludingSurcharges) {
            golfRate.Price = golfRate.PriceWithSurcharge || golfRate.Price || 0
        }
        $('#nav').html( navbarTpl( {
            Customization:app.customization,
            Localization : app.localization,
            services : app.data.serviceTypes,
            languages : app.data.languageNames,
            siteName : app.localization.siteName,
            backLink : app.customization.serverURL
        }) );
        $('#main').html( contentTpl( {
            Localization : app.localization,
            bannerMessage : app.localization.golf.marketing.bannerMessage,
            service : service
        }) );
        $('#content').addClass('golfBookConfirm').html( golfBookConfirm( {
            Localization : app.localization,
            golfRate: golfRate,
            location: location,
            course: course,
            dateTime: dateTime,
            date: dateTime.substr(0,10),
            time: dateTime.substr(10),
            numberOfPlayers: numberOfPlayers,
            total: numberOfPlayers * (golfRate ? golfRate.Price : 0),
            CustomerId: app.data.CustomerId
        } ));
        $('#breadcrumbs').html( breadcrumbsTpl({
            'breadCrumbs':app.data.breadCrumbs.golf
        }) )
        commonViewHelper.updateNavBar(service,app.language,app.models.systemModel.dataModel.folioBalance.data[app.models.systemModel.makeStandardName(app.models.systemModel.dataModel.folioBalance,{})]);
        commonViewHelper.showMessages();
        commonViewHelper.prepGolfConfirmForm();
    });
    return window.app.views.golfView = golfView;
});

